import { render } from "./UserDetails.vue?vue&type=template&id=70ff5fc8&scoped=true&ts=true"
import script from "./UserDetails.vue?vue&type=script&lang=ts"
export * from "./UserDetails.vue?vue&type=script&lang=ts"

import "./UserDetails.vue?vue&type=style&index=0&id=70ff5fc8&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70ff5fc8"]])

export default __exports__